import BatteryGraph from './BatteryGraph'

export default BatteryGraph;